module.exports = __webpack_public_path__ + "img/gy.3485b821.svg";